@if (showDropdown && filteredItems.length > 0) {
    <div class="user-mention-dropdown" #dropdown>
        <div class="user-list">
            @for (item of filteredItems; track item; let i = $index) {
                <div
                    class="user-item"
                    [class.selected]="i === selectedIndex"
                    [attr.data-index]="i"
                    (click)="selectItem(item)"
                    (mouseenter)="selectedIndex = i">
                    <div class="user-info">
                        <div class="user-name">
                            @if (item.type === 'user') {
                                <span>{{ item.name }}</span>
                            }
                            @if (item.type === 'role') {
                                <span class="role-name">{{ item.name }}</span>
                            }
                        </div>
                        @if (item.email) {
                            <div class="user-email">{{ item.email }}</div>
                        }
                    </div>
                </div>
            }
        </div>
    </div>
}
